import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseTemplate from '../BaseTemplate';
import { Button, Label } from '../../atoms';
import cn from 'classnames';
import styles from './ReportingDetailsVerificationStatusesAddTemplate.module.css';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import {
  ReportingDetailsVerificationStatusForm,
  TranslationOrganism,
} from '../../organisms';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface ReportingDetailsVerificationStatusesAddTemplateProps {
  data: VerificationStatusResponseDto;
  handleAddVerificationStatus: (
    verificationStatus: VerificationStatusResponseDto
  ) => void;
  handleOnChange: (verificationStatus: VerificationStatusResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsVerificationStatusesAddTemplate: FC<
  ReportingDetailsVerificationStatusesAddTemplateProps
> = ({
  data,
  handleAddVerificationStatus,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Create Verification Status" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/verification-statuses')}
          className={cn(styles.buttonLink)}
        >
          Go back to verification status overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsVerificationStatusForm
        data={data}
        handleVerificationStatus={handleAddVerificationStatus}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsVerificationStatusesAddTemplate;
